import React, { Component } from 'react';
// import { allStepContent } from '../config'
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
class RegisterStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showBox: true
    }
  }
  close = () => {
    this.setState({
      showBox: false
    })
  }
  open = () => {
    this.setState({
      showBox: true
    })
  }
  render() {
    return <PhotoProvider>
      {
        this.props.appState.mainContent.map((item, index) => {
          return (
              <div className={`register-group step-group${index}`} key={ index }>
                {
                  item.map((_) => {
                    return (
                      <div key={ _.key } className="register-inner">
                        <p className='step-title'>{ _.key }</p>
                        {
                          _.img ?
                          <PhotoConsumer key={_.key} src={_.img}>
                            <img src={ _.img } alt="step-img" />
                          </PhotoConsumer>
                          : ''
                        }
                        <div dangerouslySetInnerHTML={{ __html: _.content }} className="step-msg"></div>
                      </div>
                    )
                  })
                }
              </div>
            )
          })
      }
      </PhotoProvider>
    }
}

export default RegisterStep